import styles from './StatsCards.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { SvgIcon } from '../SvgIcon';
import { SvgIconSrc } from '../SvgIcon/SvgIcon.constants';
import classNames from 'classnames';

export const StatCard = ({
  title,
  value,
  subtitle,
  trend,
  children,
  contaninerClassName,
}) => {
  return (
    <div className={classNames(styles.statCard, contaninerClassName)}>
      <div className={styles.statHeader}>{title}</div>

      <div className={styles.statContent}>
        {children}

        <div className={styles.statText}>
          <div className={styles.value}>{value}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {trend && <div className={styles.trend}>{trend.text}</div>}
        </div>
      </div>
    </div>
  );
};

export const ProductivityScoreCard = ({
  productivityScore,
  contaninerClassName,
  chartConfig,
}) => {
  const productivityScoreValue = Number(productivityScore.replace('%', ''));
  return (
    <StatCard
      title="PRODUCTIVITY SCORE"
      value={productivityScore}
      trend={{ type: 'up' }}
      contaninerClassName={contaninerClassName}
    >
      <div style={{ width: '62px', height: '62px' }}>
        <Doughnut
          options={{
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            cutout: '10%',
            tooltip: {
              enabled: false,
            },
          }}
          data={{
            labels: ['', ''],
            datasets: [
              {
                data: [productivityScoreValue, 100 - productivityScoreValue],
                backgroundColor: chartConfig?.backgroundColor || [
                  '#121F5C',
                  'white',
                ],
              },
            ],
          }}
        />
      </div>
    </StatCard>
  );
};

export const TotalTimeTrackedCard = ({
  totalTimeTracked,
  contaninerClassName,
}) => {
  return (
    <StatCard
      title="TOTAL TIME TRACKED"
      value={totalTimeTracked}
      contaninerClassName={contaninerClassName}
    >
      <SvgIcon src={SvgIconSrc.uptrend} className={styles.trendIcon} />
    </StatCard>
  );
};

export const IdleTimeCard = ({ idleTime, contaninerClassName }) => {
  return (
    <StatCard
      title="IDLE / REST"
      value={idleTime}
      contaninerClassName={contaninerClassName}
    >
      <SvgIcon src={SvgIconSrc.downtrend} className={styles.downtrendIcon} />
    </StatCard>
  );
};
